var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight16 = function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.053 7.341 9.527 5.818V5.81a.66.66 0 0 1 0-.945.66.66 0 0 1 .946 0l2.667 2.662c.157.152.22.369.186.573a.67.67 0 0 1-.26.437l-2.6 2.595a.7.7 0 0 1-.473.193l.007.007a.68.68 0 0 1-.474-.193.664.664 0 0 1-.006-.944v-.007l1.52-1.517H3.333a.664.664 0 0 1-.667-.665.66.66 0 0 1 .667-.666h7.72Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight16;